module.exports = "/assets/dist/images/carsaver_logo.svg?02fafc6efe0ae2002cd5d4027810a678";